
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/business/checkout",
      function () {
        return require("private-next-pages/business/checkout.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/business/checkout"])
      });
    }
  